export default __webpack_public_path__ + "static/media/referral-claim@3x.b687295d.png";